import React, { useEffect } from "react";
import Banner from "../../components/Home/Banner";
import DestinationSection from "./DestinationSection";
import WeekendDeals from "./WeekendDeals";
import BookSection from "./BookSection";
import { Helmet } from "react-helmet";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { getAllServicesForHome } from "./services/home.services";
import Loading from "../../components/spinner/Loading";
import FullLoading from "../../components/spinner/FullLoading";
// import { ErrorToast, SuccessToast } from "../../toast/Toasts";

const Home = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.home.loading);

  useEffect(() => {
    dispatch(getAllServicesForHome());
  }, []);

  // const handleClick = () => {
  //   SuccessToast("Hello, Toast Successfully!");
  //   ErrorToast("Hello, Toast Error Successfully!");
  // };
  return (
    <>
      <FullLoading loading={loading} />
      <Banner />
      {/* <ExclusiveOfferSection /> */}
      {/* <button onClick={handleClick}>Hello Toast</button> */}
      <DestinationSection />
      <WeekendDeals />
      <BookSection />
      {/* <PopularItems /> */}
      <Helmet>
        <style>{`
          body {
            background: white;
          }
        `}</style>
      </Helmet>
    </>
  );
};

export default Home;
